import styled from "@emotion/styled";

const Checkbox = styled.input`
  width: 32px;
  height: 32px;
  border: 2px solid #f0f0f0;
  border-radius: 100%;

  &:checked {
    background: url("/assets/circled-check-full.svg") no-repeat center;
    border: none;
  }
`;

Checkbox.defaultProps = { type: "checkbox", role: "checkbox" };

export default Checkbox;
